import Drawer from "@mui/material/Drawer";
import useMediaQuery from "@mui/material/useMediaQuery";
import type React from "react";

interface SidenavDrawerProps {
  open: boolean;
  children: React.ReactNode;
  mobileBreakpoint?: number;
}

export default function SidenavDrawer({ open, children, mobileBreakpoint = 1199 }: SidenavDrawerProps) {
  const isNotDesktop = useMediaQuery(`(max-width:${mobileBreakpoint}px)`);

  return (
    <>
      {isNotDesktop ? (
        <Drawer
          variant="temporary"
          open={open}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", lg: "none" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: "100%", bgcolor: "#FFFFFF" },
          }}
        >
          {children}
        </Drawer>
      ) : (
        <Drawer
          variant="permanent"
          anchor="left"
          sx={{
            display: { xs: "none", lg: "block" },
            flexShrink: 0,
            width: 366,
            "& .MuiDrawer-paper": {
              width: 366,
              boxSizing: "border-box",
              bgcolor: "#FFFFFF",
            },
          }}
        >
          {children}
        </Drawer>
      )}
    </>
  );
}
